// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__QDe2O","modalFooterButton":"ModalNotes_modalFooterButton__2rlb0"};